import { QuickScore } from "quick-score";
import { Adapter } from "@/adapters/Adapter";
export class QuickScoreAdapter extends Adapter {
    constructor() {
        super(...arguments);
        this.name = "QuickScore";
    }
    initScorer() {
        return this.scorer = new QuickScore(this.items, this.options);
    }
    update(items, hash) {
        this.items = items;
        this.hash = hash;
        // cast the scorer property to a QuickScore so we can call its
        // setItems() method
        this.scorer.setItems(this.items);
    }
}
